import a from "./_getMapData.js";
function i(e) {
  var t = a(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
export {
  i as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_mapCacheDelete.js
// module id = 1534
// module chunks = 67